 import React from "react";
import { Nav, NavLink, NavMenu } from "./NavbarElements";
import DashboardIcon from '../../assets/images/dashboard-icon.svg';
import OrdersIcon from '../../assets/images/orders-icon.svg';
import CustomersIcon from '../../assets/images/customers-icon.svg';
import DriversIcon from '../../assets/images/drivers-icon.svg';
import ServiceareaIcon from '../../assets/images/service-area-icon.svg';
import PriceIcon from '../../assets/images/price-icon.svg';
import PasswordIcon from '../../assets/images/password-icon.svg';

const Navbar = () => {
    return (
        <>
            <Nav>
                <NavMenu>
                    <ul className="sidebar leftmenus">
                        <span className="closeSidebar"></span>
                        <li><NavLink to="/dashboard" activeStyle><img src={DashboardIcon} alt="icon" /><span>Dashboard</span></NavLink></li>
                        <li><NavLink to="/manage-orders" activeStyle><img src={OrdersIcon} alt="icon" /><span>Manage Orders</span></NavLink></li>
                        <li><NavLink to="/customers" activeStyle><img src={CustomersIcon} alt="icon" /><span>Customers</span></NavLink></li>
                        <li><NavLink to="/manage-drivers" activeStyle><img src={DriversIcon} alt="icon" /><span>Manage Drivers</span></NavLink></li>           
                        <li><NavLink to="/manage-service-area" activeStyle><img src={ServiceareaIcon} alt="icon" /><span>Manage Service Area</span></NavLink></li>
                        <li><NavLink to="/manage-price" activeStyle><img src={PriceIcon} alt="icon" /><span>Manage Price</span></NavLink></li>
                        <li><NavLink to="/change-password" activeStyle><img src={PasswordIcon} alt="icon" /><span>Change Password</span></NavLink></li>
                    </ul>
                </NavMenu>
            </Nav>
        </>
    );
};
 
export default Navbar;